import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f63bffb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "parent" }

import {computed, nextTick, reactive, ref, watchEffect} from 'vue';

import {windows} from '@/components/common/window/Windows';
import {PageList} from '@/models/PageList';
import {SelectRemoteFieldType} from "@/components/business/crud/interface/FieldType";
import {Select} from "ant-design-vue";
import _ from "lodash";


interface Option {
  label: string;
  value: string;
}



export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRemoteMulti',
  props: {
    title: {},
    widget: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

/**
 * 获取搜索方法
 * @param cb
 */
function useSearch() {
  // 之前的关键字
  const loading = ref(false);
  const keyword = ref("");

  // 关键字搜索
  async function search(kw: string) {
    keyword.value = kw;
    loading.value = false;
  }

  const debounceSearch = _.debounce(search, 800);
  const finalSearch = async (kw: string, flush = false) => {
    loading.value = true;
    await debounceSearch(kw);
    if (flush) {
      debounceSearch.flush();
    }
  };
  return [finalSearch, keyword, loading] as const;
}

const dataParser = (item: Record<string, any>) => {
  return {
    label: item[props.widget.labelFieldName],
    value: item[props.widget.valueFieldName],
  };
};

const value = computed({
  get: () => {
    return props.modelValue instanceof Array ? props.modelValue.map(dataParser) : [];
  },
  set: v => {
    if (v instanceof Array && v.length > 0) {
      emit("update:modelValue", v.map(i => ({
        [props.widget.labelFieldName]: i.label,
        [props.widget.valueFieldName]: i.value,
      })));
    } else {
      emit("update:modelValue", []);
    }
  }
})

function VNodes(_: any, {attrs}: any) {
  return attrs.vnodes;
}

const [search, kw] = useSearch();
const condition = computed(() => {
  const value = {
    $and: [] as any
  };
  if (kw.value) {
    value.$and.push({
      [props.widget.labelFieldName]: {$like: '%' + kw.value + '%'}
    })
  }
  if (props.widget.condition) {
    value.$and.push(props.widget.condition)
  }
  return value;
})
const config = reactive({
  path: props.widget.path,
  pageSize: 8,
  condition: condition.value,
  load: [props.widget.labelFieldName, props.widget.valueFieldName],
  parser: async (origin: any[]) => {
    return origin.map(dataParser);
  },
})
// 远程数据
const list = new PageList<Option>(config);
watchEffect(() => {
  config.condition = condition.value;
})
list.init();


const open: any = ref();
// 选项为空创建
let createHandler: (() => any) | undefined;
if (props.widget.createPagePath !== undefined) {
  createHandler = async () => {
    if (props.widget.createPagePath !== undefined) {
      open.value = false;
      await nextTick(() => {
        open.value = undefined;
      });
      select.value.blur();
      // 打开创建页面，等待创建完成
      const id = windows.open({
        content: {
          type: 'route',
          href: props.widget.createPagePath,
        },
        title: '创建' + props.title,
      });
      const res = await windows.getCloseData(id);
      if (res) {
        value.value = [...value.value, {
          label: res[props.widget.labelFieldName],
          value: res[props.widget.valueFieldName],
        }]
        await list.refresh();
      }
    }
  };
}

const select = ref<InstanceType<typeof Select>>();


return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_select, {
      "label-in-value": "",
      value: value.value,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
      style: {"width":"100%"},
      mode: "multiple",
      "filter-option": false,
      showSearch: true,
      onSearch: _unref(search),
      open: open.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((open).value = $event)),
      onFocus: _cache[4] || (_cache[4] = ($event: any) => (_unref(search)('', true))),
      onSelect: _cache[5] || (_cache[5] = ($event: any) => (_unref(search)('', true))),
      options: _unref(list).data.list,
      allowClear: true,
      placeholder: '选择' + _ctx.title,
      ref_key: "select",
      ref: select
    }, {
      dropdownRender: _withCtx(({ menuNode: menu }) => [
        _createVNode(VNodes, { vnodes: menu }, null, 8, ["vnodes"]),
        (_unref(createHandler) || _unref(list).data.count > _unref(list).data.pageSize)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
              _createElementVNode("div", {
                class: "drop-menu",
                onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
              }, [
                (_unref(createHandler))
                  ? (_openBlock(), _createBlock(_component_sc_btn, {
                      key: 0,
                      type: "link",
                      text: "创建",
                      handler: _unref(createHandler)
                    }, null, 8, ["handler"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_pagination, {
                  simple: "",
                  "hide-on-single-page": "",
                  responsive: "",
                  "show-less-items": "",
                  "show-quick-jumper": "",
                  current: _unref(list).data.pageNum,
                  "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(list).data.pageNum) = $event)),
                  "page-size": _unref(list).data.pageSize,
                  total: _unref(list).data.count
                }, null, 8, ["current", "page-size", "total"])
              ], 32)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "onSearch", "open", "options", "placeholder"])
  ], 512))
}
}

})